import { Division } from '@chargify/data-access';

export const formatOptions = (options: Division[]) =>
  options.map(({ code, name }) => ({ label: name, value: code }));
